import { Inbox } from 'lucide-react';

export function EmptyState({ title = 'Nenhum dado', description, icon: Icon = Inbox }: { title?: string; description?: string; icon?: any }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="rounded-full bg-muted p-4 mb-3">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <div className="font-medium">{title}</div>
      {description && <div className="text-sm text-muted-foreground mt-1 max-w-md">{description}</div>}
    </div>
  );
}
